<template>
    <div>
        <form>
            <div class="row project-cards">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Contratos</h3>
                                    <br />
                                </div>
                                <div class="col-lg-4 col-md-6" v-for="(contract,index) in contracts" :key="index" >
                                    <div class="project-box">
                                        <h6>{{ contract.type == "contract" ? "Contrato Indeterminado de Trabajo" : "Reglamento Interno de Trabajo" }}</h6>
                                        <br />
                                        <div class="d-flex mb-3">
                                            <div class="flex-grow-1 project-box-item">
                                                <span style="float: right; text-align: right;" v-if="contract.sign_location">
                                                    {{ contract.sign_date ? $formatDate(contract.sign_date) : '-' }}
                                                    <br />
                                                    {{ contract.sign_location }}
                                                </span>
                                                <p>{{ contract.sign_location ? "Firmado" : 'Por firmar' }}</p>
                                                <br />
                                                
                                                Fecha de Contrato: <span style="float: right; text-align: right;">{{ contract.contract_date ? $formatDate(contract.contract_date) : '' }}</span><br/>
                                                Fecha de Envío: <span style="float: right; text-align: right;">{{ contract.notify_date ? $formatDate(contract.notify_date) : 'Por Enviar' }}</span><br/>
                                                Fecha de Recepción: <span style="float: right; text-align: right;">{{ contract.view_date ? $formatDate(contract.view_date) : 'Por Visualizar' }}</span><br/>
                                                <br />
                                                <b>Fecha de Firma: <span style="float: right; text-align: right;">{{ contract.sign_date ? $formatDate(contract.sign_date) : 'Por Firmar' }}</span><br/></b>
                                                <br />
                                            </div>
                                        </div>
                                        <button class="btn btn-primary btn-xs" @click="signContractModal(employee, contract.type)" type="button" style="float: right;" title="btn btn-success btn-sm"  data-bs-toggle="modal" data-bs-target=".employee-signing-modal">Firmar</button>
                                        <button v-if="employee.is_active" class="btn btn-info btn-xs" type="button" @click="showContract(employee, contract.type)" title="btn btn-success btn-sm" style="float: right; margin-right: 10px;">Ver Contrato</button>
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="modal fade employee-signing-modal" tabindex="-1" role="dialog" aria-labelledby="employeeSigningModalLabel" aria-hidden="true">
            <EmployeeSigningModal ref="employeeSigningModal" />
        </div>
    </div>
</template>
<script>

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import EmployeeSigningModal from "@/components/tmkt/employees/employees_sign_modal.vue";

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import ws from '@/services/employees'

export default {
    name: 'employee_contracts_tab',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker,
        EmployeeSigningModal
    },
    data(){
        return{
            employee: null,
            token: '',
            contracts: []
        }
    },
    methods: {
        async loadEmployee(employee, token){
            this.employee = employee;
            this.token = token;

            let response = await ws.getContracts(this.token);

            if(response.type == "success"){
                this.contracts = response.data;
            }

            this.setForm(this.employee);
        },
        async showContract(employee, contract_type){
            let response = await ws.downloadDocument(employee, contract_type);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                window.open(response.data, '_blank');
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async signContractModal(employee, contract_type){
            this.$refs.employeeSigningModal.loadEmployee(employee, contract_type);
        },
        async updateGeneralEmployee(form) {
            let response = await ws.updateEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.$emit('refresh', response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        validations(){
            this.updateEmployeeInformationValidation();
        }
    }
}
</script>
<style>
    .dp1{
        input {
            height: 24px;
        }
    }
</style>